import ImageComparisonSlider from './image-comparison-slider'
export default ImageComparisonSlider
